import { takeEvery, put, call } from "redux-saga/effects";
import {
  GET_ADMINS,
  POST_ADD_ADMIN,
  DELETE_ADMIN,
  CREATE_MANAGER,
  GET_WORKSPACE_DETAILS,
  UPDATE_WORKSPACE_DETAILS,
  UPDATE_WORKSPACE_USER,
  DELETE_WORKSPACE_USER,
  TOGGLE_ACCOUNT_STATUS,
} from "./actionTypes";

import {
  getadminFail,
  getadminSuccess,
  addAdminSuccess,
  addAdminFail,
  deleteAdminSuccess,
  deleteAdminFail,
  createManagerSuccess,
  createManagerFail,
  workspaceDetailsFail,
  workspaceDetailsSuccess,
  updateWorkspaceSuccess,
  updateWorkspaceFail,
  updateWorkspaceUserSuccess,
  updateWorkspaceUserFail,
  deleteWorkspaceUserSuccess,
  deleteWorkspaceUserFail,
  toggleAccountStatusSuccess,
  toggleAccountStatusFail,
} from "./actions";

import {
  getAdminList,
  postAddAdmin,
  postDeleteAdmin,
  postAddManager,
  onTogglingAccountStatus,
  onDeletingWorkspaceUser,
  onGettingWorkspaceDetails,
  onUpdatingWorkspaceDetails,
  onUpdatingWorkspaceUserDetails,
} from "helpers/fakebackend_helper";
import showToast from "common/Notification";
import { responseHandler } from "common/CommanFunction";

const toastTitle = "Super Admin";

function* Get_ADMINSLIST() {
  try {
    const response = yield call(getAdminList);
    yield put(getadminSuccess(response));
  } catch (error) {
    yield put(getadminFail(error));
  }
}

function* onToggleAccountStatus({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onTogglingAccountStatus, data);
    yield call(responseHandler, toastTitle, response, toggleAccountStatusSuccess, toggleAccountStatusFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(toggleAccountStatusFail(error));
    showToast("error", "Super Admin", error);
  }
}

function* POST_AddAdmin({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(postAddAdmin, data);
    yield call(responseHandler, toastTitle, response, addAdminSuccess, addAdminFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(addAdminFail(error));
    showToast("error", "Super Admin", error);
  }
}

function* POST_AddManager({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(postAddManager, data);
    yield call(responseHandler, toastTitle, response, createManagerSuccess, createManagerFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(createManagerFail(error));
    showToast("error", "Super Admin", error);
  }
}

function* POST_Delete({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(postDeleteAdmin, data);
    yield call(responseHandler, toastTitle, response, deleteAdminSuccess, deleteAdminFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteAdminFail(error));
    showToast("error", "Super Admin", error);
  }
}

function* onGetWorkspaceDetails({ payload: data }) {
  try {
    const response = yield call(onGettingWorkspaceDetails, data);
    if (response.status) {
      yield put(workspaceDetailsSuccess(response));
    } else {
      showToast("warning", "Super Admin", response.message);
      yield put(workspaceDetailsFail(response));
    }
  } catch (error) {
    yield put(workspaceDetailsFail(error));
    showToast("error", "Super Admin", error);
  }
}

function* onUpdateWorkspaceDetails({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingWorkspaceDetails, data);
    yield call(responseHandler, toastTitle, response, updateWorkspaceSuccess, updateWorkspaceFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateWorkspaceFail(error));
    showToast("error", "Super Admin", error);
  }
}

function* onUpdateWorkspaceUserDetail({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onUpdatingWorkspaceUserDetails, data);
    yield call(responseHandler, toastTitle, response, updateWorkspaceUserSuccess, updateWorkspaceUserFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(updateWorkspaceUserFail(error));
    showToast("error", "Super Admin", error);
  }
}

function* onDeleteWorkspaceUser({ payload: { data, onSuccess, onError } }) {
  try {
    const response = yield call(onDeletingWorkspaceUser, data);
    yield call(responseHandler, toastTitle, response, deleteWorkspaceUserSuccess, deleteWorkspaceUserFail, onSuccess, onError);
  } catch (error) {
    onError();
    yield put(deleteWorkspaceUserFail(error));
    showToast("error", "Super Admin", error);
  }
}

export function* watch_admins() {
  yield takeEvery(GET_ADMINS, Get_ADMINSLIST);
  yield takeEvery(DELETE_ADMIN, POST_Delete);
  yield takeEvery(POST_ADD_ADMIN, POST_AddAdmin);
  yield takeEvery(CREATE_MANAGER, POST_AddManager);
  yield takeEvery(TOGGLE_ACCOUNT_STATUS, onToggleAccountStatus);
  yield takeEvery(GET_WORKSPACE_DETAILS, onGetWorkspaceDetails);
  yield takeEvery(UPDATE_WORKSPACE_DETAILS, onUpdateWorkspaceDetails);
  yield takeEvery(UPDATE_WORKSPACE_USER, onUpdateWorkspaceUserDetail);
  yield takeEvery(DELETE_WORKSPACE_USER, onDeleteWorkspaceUser);
}

export default watch_admins;
